export const HUBSPOT_HOSTED = 'HUBSPOT_HOSTED';